<template>
    <div class="is-pulled-right chart-filter" v-if="filters && filters.length > 0">
        <div @click="openPopover">
            <b-icon
                :id="'filter-icon-' + title"
                icon="dots-vertical"
            />
        </div>
        <transition name="pop-fade">
            <div class="pop" v-show="popoverShow" ref="popover" :id="`popover-${title}`">
                <div class="popover-chart-filter" v-for="(f, i) in filters" :key="i">
                    <div v-if="f && f.type == 'dropdown'">
                        <label v-text="$t(f.label)" v-if="f.label"/>
                        <v-select
                            :options="f.options"
                            :value="f.value"
                            v-model="f.value"
                            :getOptionLabel="getLabel"
                            class="no-clear"
                        >
                            <template slot="option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template slot="no-options">{{$t('sem-resultados')}}</template>
                        </v-select>
                    </div>
                    <div v-if="f && f.type == 'input'">
                        <label v-text="$t(f.label)" v-if="f.label"/>
                        <v-input
                            v-model="f.value"
                            :placeholder="f.placeholder"
                        />
                    </div>
                    <div v-if="f && f.type == 'radio'">
                        <label v-text="$t(f.label)" v-if="f.label"/>
                        <label class="radio-box" v-for="(o, i) in f.options" :key="i">
                            {{ $t(o.label) }}
                            <input
                                type="radio"
                                :name="title + '-' + f.label"
                                :value="o.value"
                                v-model="f.value"
                            >
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
                <button class="save-btn" type="button" @click="aplicarFiltro">
                    {{ $t('salvar') }}
                </button>
                <button class="delete-btn" type="button" @click="onClose">
                    {{ $t('fechar') }}
                </button>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'ChartFilter',
    props: ['filters', 'title'],
    data() {
        return {
            popoverShow: false,
            filtroAtual: []
        }
    },
    created () {
        this.getFiltroAtual();

        let prev = document.getElementById(`popover-${this.title}`);

        if (prev != null) {
            prev.remove();
        }
    },
    mounted () {
        // Transferindo o popver pra fora do container para não dar problemas com o select
        if (this.$refs.popover != undefined) {
            document.querySelector('.hc').append(this.$refs.popover);

            document.querySelector('.conteudo.bg').addEventListener('scroll', this.scrollEvt);
        }
    },
    beforeDestroy() {
        let el = document.getElementById(`popover-${this.title}`);
        
        if (el != null) {
            el.remove();
        }

        document.querySelector('.conteudo.bg').removeEventListener('scroll', this.scrollEvt);
    },
    methods: {
        aplicarFiltro () {
            this.onClose();
            this.getFiltroAtual();
            this.$emit('aplicar-filtro', this.filtroAtual);
        },
        onClose () {
            this.popoverShow = false;
        },
        getLabel(option) {
            return this.$t(option.label);
        },
        getFiltroAtual () {
            if (this.filters) {
                this.filtroAtual = this.filters.map(f => {
                    return {
                        id: f.id,
                        label: f.label,
                        value: f.value,
                        type: f.type
                    };
                });
            }
        },
        openPopover () {
            if (!this.popoverShow) {
                this.translateToPos();
                this.popoverShow = true;
            }
        },
        translateToPos () {
            let rect = document.getElementById('filter-icon-' + this.title).getBoundingClientRect();

            if (rect != null) {
                this.$refs.popover.style.transform = `translate(${rect.left - 200}px, ${rect.top - 25}px)`;
            }
        },
        scrollEvt () {
            if (this.popoverShow) {
                this.translateToPos();
            }
        }
    }
}
</script>

<style lang="scss">
    .save-btn, .delete-btn {
        margin-left: 0 !important;
    }

    .chart-filter {
        .icon {
            cursor: pointer;
            color: $light-gray-color;
            margin-right: 5px;
        }
    }

    .pop {
        position: absolute;
        width: 220px;
        padding: 10px;
        border: 1px solid $table-border;
        border-radius: 5px;
        background-color: $sovis-white;
        z-index: 0;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
    }

    .pop-fade-enter-active, .pop-fade-leave-active {
        transition: opacity .3s ease;
    }

    .pop-fade-enter, .pop-fade-leave-to {
        opacity: 0;
    }
</style>